import { Field, useFormikContext } from "formik";
import { motion } from "framer-motion";
import { ChangeEvent, FC, useState } from "react";
import { OrderFormValues } from "../lib/contexts/FormikContext";
import { Product } from "../lib/types";

interface Props {
  selectedProducts: Product[];
  currentStep: number;
  setCurrentStep: (s: number) => void;
}
export const OrderForm: FC<Props> = ({
  currentStep,
  setCurrentStep,
  selectedProducts,
}) => {
  const [ownerError, setOwnerError] = useState<string>();
  const [invoiceAddress, setInvoiceAddress] = useState<boolean>(false);

  const errorInputClasses = "border border-red-500 error-input";
  const errorMsgClasses = "text-red-500 text-sm error-msg";
  const {
    errors,
    values,
    touched,
    validateForm,
    isValid,
    dirty,
    setFieldValue,
  } = useFormikContext<OrderFormValues>();

  console.log(
    `touched: ${JSON.stringify(
      touched,
      null,
      2
    )}, dirty: ${dirty}, isValid: ${isValid}`
  );

  if (currentStep > 1 && dirty) {
    return (
      <motion.div
        layout
        className="w-full shadow-xl p-8 bg-[#374F5A] text-white rounded-lg"
      >
        <div className="flex flex-col md:flex-row justify-between items-end ">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
            <div>
              <strong>Namn och Address</strong>
              <br />
              {`${values.firstname} ${values.lastname}`}
              <br />
              {values.address_co && (
                <>
                  c/o {values.address_co}
                  <br />
                </>
              )}
              {`${values.address_street} ${values.address_streetno}${
                values.address_letter
              }${
                values.address_apartment
                  ? ", Lgh. " + values.address_apartment
                  : ""
              }`}
              <br />
              {`${values.address_zip} ${values.address_city}`}
            </div>
            <div>
              <strong>Fakturaadress</strong>
              <br />
              {values.invoice_street ? (
                <>
                  {values.invoice_co && (
                    <>
                      c/o {values.invoice_co}
                      <br />
                    </>
                  )}
                  {`${values.invoice_street} ${values.invoice_streetno}${
                    values.invoice_letter
                  }${
                    values.invoice_apartment
                      ? ", Lgh. " + values.invoice_apartment
                      : ""
                  }`}
                </>
              ) : (
                <>Samma som postadress</>
              )}
            </div>
            <div>
              <strong>Övriga uppgifter</strong>
              <br />
              Personnummer: {values.personalnumber}
              <br />
              Mobilnummer: {values.mobile}
              <br />
              E-post: {values.email}
              <br />
            </div>
          </div>
          <div>
            <button
              className=" rounded-full px-4 py-1 inline-block text-[#374F5A] bg-white"
              onClick={() => setCurrentStep(1)}
            >
              Ändra
            </button>
          </div>
        </div>
      </motion.div>
    );
  } else if (currentStep !== 1) {
    return null;
  }
  return (
    <div>
      {/* <Formik
      initialValues={{
        firstname: "",
        lastname: "",
        email: "",
        mobile: "",
        personalnumber: "",
        address_street: "",
        address_streetno: "",
        address_letter: "",
        address_co: "",
        address_apartment: "",
        address_zip: "",
        address_city: "",
        invoice_street: "",
        invoice_streetno: "",
        invoice_letter: "",
        invoice_co: "",
        invoice_apartment: "",
        invoice_zip: "",
        invoice_city: "",
        message: "",
      }}
      validationSchema={yupOrderFormSchema}
      onSubmit={(values) => console.log(values)}
    > */}
      {/* {(formik) => {
        const {
          errors,
          values,
          touched,
          validateForm,
          isValid,
          dirty,
          setFieldValue,
        } = formik;
        if (currentStep !== 1 && dirty) {
          return values.firstname;
        } else if (currentStep !== 1) {
          return null;
        }
        if (currentStep === 1) {
          return ( */}
      {/* <Form> */}
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-base tracking-wide font-sans font-bold">
          Dina uppgifter
        </h3>
        <div className="text-sm text-right">
          <span className="text-red-500">*</span> markerar obligatoriska fält.
        </div>
      </div>
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 mb-8">
        <label className="flex flex-col gap-2">
          <div className="uppercase text-xs font-bold tracking-widest">
            Förnamn <span className="text-red-500">*</span>
          </div>
          <Field
            type="text"
            name="firstname"
            id="firstname"
            className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
              errors.firstname ? errorInputClasses : ""
            }`}
          />
          {errors.firstname && (
            <div className={errorMsgClasses}>{errors.firstname}</div>
          )}
        </label>
        <label className="flex flex-col gap-2">
          <div className="uppercase text-xs font-bold tracking-widest">
            Efternamn <span className="text-red-500">*</span>
          </div>
          <Field
            type="text"
            name="lastname"
            id="lastname"
            className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
              errors.lastname ? errorInputClasses : ""
            }`}
          />
          {errors.lastname && (
            <div className={errorMsgClasses}>{errors.lastname}</div>
          )}
        </label>
        <label className="flex flex-col gap-2">
          <div className="uppercase text-xs font-bold tracking-widest">
            E-post{" "}
            <span className="text-gray-400 italic">exempel@exempel.se</span>{" "}
            <span className="text-red-500">*</span>
          </div>
          <Field
            type="email"
            name="email"
            id="email"
            placeholder=""
            className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
              errors.email ? errorInputClasses : ""
            }`}
          />
          {errors.email && (
            <div className={errorMsgClasses}>{errors.email}</div>
          )}
        </label>
        <label className="flex flex-col gap-2">
          <div className="uppercase text-xs font-bold tracking-widest">
            Mobilnummer <span className="text-gray-400 italic">07XXXXXXXX</span>{" "}
            <span className="text-red-500">*</span>
          </div>
          <Field
            type="tel"
            name="mobile"
            id="mobile"
            placeholder="07XXXXXXXX"
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setFieldValue("mobile", e.target.value.replace(/\s/g, ""));
            }}
            className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
              errors.mobile ? errorInputClasses : ""
            }`}
          />
          {errors.mobile && (
            <div className={errorMsgClasses}>{errors.mobile}</div>
          )}
        </label>
        <label className="flex flex-col gap-2">
          <div className="uppercase text-xs font-bold tracking-widest">
            Personnummer{" "}
            <span className="text-gray-400 italic">ÅÅÅÅMMDD-NNNN</span>
            <span className="text-red-500">*</span>
          </div>
          <Field
            type="text"
            name="personalnumber"
            id="personalnumber"
            className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
              errors.personalnumber ? errorInputClasses : ""
            }`}
          />
          {errors.personalnumber && (
            <div className={errorMsgClasses}>{errors.personalnumber}</div>
          )}
        </label>
      </div>
      <h3 className="text-base tracking-wide font-sans font-bold mb-6">
        Postadress
      </h3>
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 mb-8">
        <label className="flex flex-col gap-2">
          <div className="uppercase text-xs font-bold tracking-widest">
            Gata <span className="text-red-500">*</span>
          </div>
          <Field
            type="text"
            name="address_street"
            id="address_street"
            className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
              errors.address_street ? errorInputClasses : ""
            }`}
          />
          {errors.address_street && (
            <div className={errorMsgClasses}>{errors.address_street}</div>
          )}
        </label>
        <label className="flex flex-col gap-2">
          <div className="uppercase text-xs font-bold tracking-widest">
            Gatunummer <span className="text-red-500">*</span>
          </div>
          <Field
            type="text"
            name="address_streetno"
            id="address_streetno"
            className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
              errors.address_streetno ? errorInputClasses : ""
            }`}
          />
          {errors.address_streetno && (
            <div className={errorMsgClasses}>{errors.address_streetno}</div>
          )}
        </label>
        <label className="flex flex-col gap-2">
          <div className="uppercase text-xs font-bold tracking-widest">
            Ev bokstav
          </div>
          <Field
            type="text"
            name="address_letter"
            id="address_letter"
            className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
              errors.address_letter ? errorInputClasses : ""
            }`}
          />
          {errors.address_letter && (
            <div className={errorMsgClasses}>{errors.address_letter}</div>
          )}
        </label>
        <label className="flex flex-col gap-2">
          <div className="uppercase text-xs font-bold tracking-widest">
            Ev c/o adress
          </div>
          <Field
            type="text"
            name="address_co"
            id="address_co"
            className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
              errors.address_co ? errorInputClasses : ""
            }`}
          />
          {errors.address_co && (
            <div className={errorMsgClasses}>{errors.address_co}</div>
          )}
        </label>
        <label className="flex flex-col gap-2">
          <div className="uppercase text-xs font-bold tracking-widest">
            Ev lägenhetsnummer
          </div>
          <Field
            type="text"
            name="address_apartment"
            id="address_apartment"
            className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
              errors.address_apartment ? errorInputClasses : ""
            }`}
          />
          {errors.address_apartment && (
            <div className={errorMsgClasses}>{errors.address_apartment}</div>
          )}
        </label>
        <div />
        <label className="flex flex-col gap-2">
          <div className="uppercase text-xs font-bold tracking-widest">
            Postnummer <span className="text-gray-400 italic">XXX XX</span>{" "}
            <span className="text-red-500">*</span>
          </div>
          <Field
            type="text"
            name="address_zip"
            id="address_zip"
            placeholder="97323"
            className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
              errors.address_zip ? errorInputClasses : ""
            }`}
          />
          {errors.address_zip && (
            <div className={errorMsgClasses}>{errors.address_zip}</div>
          )}
        </label>
        <label className="flex flex-col gap-2">
          <div className="uppercase text-xs font-bold tracking-widest">
            Postort <span className="text-red-500">*</span>
          </div>
          <Field
            type="text"
            name="address_city"
            id="address_city"
            className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
              errors.address_city ? errorInputClasses : ""
            }`}
          />
          {errors.address_city && (
            <div className={errorMsgClasses}>{errors.address_city}</div>
          )}
        </label>
      </div>
      <h3 className="text-base tracking-wide font-sans font-bold mb-6">
        Faktureringsadress
      </h3>
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 mb-8">
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name="invoiceaddress"
            value="same"
            defaultChecked={true}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setInvoiceAddress(!e.currentTarget.checked);
            }}
          />
          Samma som postadress
        </label>
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name="invoiceaddress"
            value="other"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setInvoiceAddress(e.currentTarget.checked);
            }}
          />
          Fyll i en annan faktureringsadress
        </label>
      </div>
      {invoiceAddress && (
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 mb-8">
          <label className="flex flex-col gap-2">
            <div className="uppercase text-xs font-bold tracking-widest">
              Gata <span className="text-red-500">*</span>
            </div>
            <Field
              type="text"
              name="invoice_street"
              id="invoice_street"
              className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
                errors.invoice_street ? errorInputClasses : ""
              }`}
            />
            {errors.invoice_street && (
              <div className={errorMsgClasses}>{errors.invoice_street}</div>
            )}
          </label>
          <label className="flex flex-col gap-2">
            <div className="uppercase text-xs font-bold tracking-widest">
              Gatunummer <span className="text-red-500">*</span>
            </div>
            <Field
              type="text"
              name="invoice_streetno"
              id="invoice_streetno"
              className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
                errors.invoice_streetno ? errorInputClasses : ""
              }`}
            />
            {errors.invoice_streetno && (
              <div className={errorMsgClasses}>{errors.invoice_streetno}</div>
            )}
          </label>
          <label className="flex flex-col gap-2">
            <div className="uppercase text-xs font-bold tracking-widest">
              Ev bokstav
            </div>
            <Field
              type="text"
              name="invoice_letter"
              id="invoice_letter"
              className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
                errors.invoice_letter ? errorInputClasses : ""
              }`}
            />
            {errors.invoice_letter && (
              <div className={errorMsgClasses}>{errors.invoice_letter}</div>
            )}
          </label>
          <label className="flex flex-col gap-2">
            <div className="uppercase text-xs font-bold tracking-widest">
              Ev c/o adress
            </div>
            <Field
              type="text"
              name="invoice_co"
              id="invoice_co"
              className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
                errors.invoice_co ? errorInputClasses : ""
              }`}
            />
            {errors.invoice_co && (
              <div className={errorMsgClasses}>{errors.invoice_co}</div>
            )}
          </label>
          <label className="flex flex-col gap-2">
            <div className="uppercase text-xs font-bold tracking-widest">
              Ev lägenhetsnummer
            </div>
            <Field
              type="text"
              name="invoice_apartment"
              id="invoice_apartment"
              className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
                errors.invoice_apartment ? errorInputClasses : ""
              }`}
            />
            {errors.invoice_apartment && (
              <div className={errorMsgClasses}>{errors.invoice_apartment}</div>
            )}
          </label>
          <div />
          <label className="flex flex-col gap-2">
            <div className="uppercase text-xs font-bold tracking-widest">
              Postnummer <span className="text-gray-400 italic">XXX XX</span>{" "}
              <span className="text-red-500">*</span>
            </div>
            <Field
              type="text"
              name="invoice_zip"
              id="invoice_zip"
              placeholder="97323"
              className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
                errors.invoice_zip ? errorInputClasses : ""
              }`}
            />
            {errors.invoice_zip && (
              <div className={errorMsgClasses}>{errors.invoice_zip}</div>
            )}
          </label>
          <label className="flex flex-col gap-2">
            <div className="uppercase text-xs font-bold tracking-widest">
              Postort <span className="text-red-500">*</span>
            </div>
            <Field
              type="text"
              name="invoice_city"
              id="invoice_city"
              className={`border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm ${
                errors.invoice_city ? errorInputClasses : ""
              }`}
            />
            {errors.invoice_city && (
              <div className={errorMsgClasses}>{errors.invoice_city}</div>
            )}
          </label>
        </div>
      )}
      {selectedProducts.find((p) => p.orderflow_show_startdate === true) && (
        <div className="mb-8">
          <h3 className="text-base tracking-wide font-sans font-bold mb-6">
            Välj önskat startdatum för serviceavtal
          </h3>
          <Field
            as="input"
            type="date"
            name="startdate"
            className="border rounded px-2"
          />
        </div>
      )}
      <h3 className="text-base tracking-wide font-sans font-bold mb-6">
        Godkännanden
      </h3>
      <div>
        {selectedProducts.find(
          (p) => p.orderflow_approve_marketing_owner === true
        ) && (
          <div className="mb-3">
            <label className="flex items-center gap-2">
              <Field
                type="checkbox"
                name="approval_owner"
                id="approval_owner"
              />
              <div>
                Jag intygar att jag är ägare av fastigheten som beställningen
                avser.
                {ownerError && (
                  <div className={errorMsgClasses}>{ownerError}</div>
                )}
              </div>
            </label>
          </div>
        )}
        {selectedProducts.find(
          (p) => p.orderflow_approve_marketing_email === true
        ) && (
          <div className="mb-3">
            <label className="flex items-center gap-2">
              <Field type="checkbox" name="approval_com_email" />
              Jag tar gärna emot information om erbjudanden från Lunet på min
              e-postadress.
            </label>
          </div>
        )}
        {selectedProducts.find(
          (p) => p.orderflow_approve_marketing_sms === true
        ) && (
          <div className="mb-6">
            <label className="flex items-center gap-2">
              <Field type="checkbox" name="approval_com_sms" />
              Jag tar gärna emot information om erbjudanden från Lunet via SMS.
            </label>
          </div>
        )}
      </div>
      <h3 className="text-base tracking-wide font-sans font-bold mb-6">
        Meddelande
      </h3>
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 mb-8">
        <label className="flex flex-col gap-2">
          <div className="uppercase text-xs font-bold tracking-widest">
            Fyll i ditt meddelande nedan
          </div>
          <Field
            as="textarea"
            name="message"
            className="border bg-white border-gray-500 rounded px-4 py-3 relative w-full max-w-sm "
            rows={4}
          ></Field>
        </label>
      </div>

      <button
        disabled={Object.keys(touched).length === 0}
        type="button"
        onClick={async () => {
          const ownerEl = document.getElementById("approval_owner");
          if (!!ownerEl) {
            // console.log("I FOUND THE OWNER CHECKBOX");
            if (values.approval_owner === false) {
              setOwnerError("Du måste godkänna att du är ägare av fastigheten");
              window.scrollTo({
                behavior: "smooth",
                top:
                  ownerEl.getBoundingClientRect().top -
                  document.body.getBoundingClientRect().top -
                  200,
                // document.querySelector(selector).getBoundingClientRect().top -
                // document.body.getBoundingClientRect().top -
                // offset,
              });
              return;
            } else {
              setOwnerError("");
            }
          }
          validateForm(values)
            .then((res) => {
              console.log("Validate res: ", res);
              console.log("💪", errors);
              if (isValid) {
                setCurrentStep(currentStep + 1);
              } else {
                console.log(errors);
                setTimeout(() => {
                  const el = document.querySelector(
                    ".error-input"
                  ) as HTMLInputElement;

                  window.scrollTo({
                    behavior: "smooth",
                    top:
                      el.getBoundingClientRect().top -
                      document.body.getBoundingClientRect().top -
                      200,
                    // document.querySelector(selector).getBoundingClientRect().top -
                    // document.body.getBoundingClientRect().top -
                    // offset,
                  });
                  // el.scrollIntoView({ behavior: "smooth", block: "start" });
                }, 300);
              }
            })
            .catch((err) => console.log(err));

          // validateForm().then(() => setCurrentStep(currentStep + 1))
          //  const valid = await validateForm().then(() => {
          //     setCurrentStep(currentStep + 1);
          //     console.log(errors);
          //   })

          //   if(valid)
          // }
        }}
        style={{ background: "#374F5A" }}
        className="rounded-full px-4 py-2 text-white inline-block  text-xs uppercase font-bold disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Gå vidare
      </button>
      {/* </Form> */}
      {/* );
        }
      }}
    </Formik> */}
    </div>
  );
};
